// Generated by CoffeeScript 1.12.6
(function() {
  angular.module('app.jobApplicationHistory')
  .controller('viewApplicationBodyCtrl', [
    '$http',
    '$log',
    '$location',
    '$scope',
    'currentLawyer',
    '$modal',
    '$window',
    '$translate',
    '$cookies',
    'logger',
    '$filter',
    'jobApplicationEmailID',
    '$sce',
    'lawyerAndAdminID',
    function($http, $log, $location, $scope, currentLawyer, $modal, $window, $translate, $cookies, logger, $filter, jobApplicationEmailID, $sce, lawyerAndAdminID) {
      $http.post('/api/fetch-current-user', {
        'contentType': 'application/json'
      }).then(function({data, status, headers, config}) {
        $scope.user = data;
        lawyerAndAdminID.setModel('user', $scope.user.userType);
      },function(data) {
        $log.info('error');
      });
      $scope.emailID = jobApplicationEmailID.getModel('emailID');
      if (!$scope.emailID) {
        $location.url('/admin/email-history');
      }
      $scope.email = [];
      $http.post('/api/fetch-job-application-history-by-id', {
        emailID: $scope.emailID
      }).then(function({data, status, headers, config}) {
        $scope.email = data;
        $scope.emailContent = $sce.trustAsHtml($scope.email.email_data);
      },function({data,status}) {
        if (status === 440) {
          $location.url('/signin');
        }
      });
      $scope.downloadCV = function() {
        var loc;
        loc = $scope.email.cv_url.replace(`${process.env.LEXSTEP_URL}`, "");
        $window.open(loc, '_blank');
      };
      $scope.backButton = function() {
        return $location.url('/admin/email-history');
      };

      return $scope.navigateToEmailListing = function() {
        $http.post('/api/admin/navigate-email-listing'.then(function({data, status, headers, config}) {
          $location.url('/admin/email-listing');
        },function(data) {
          $log.info('error');
        }));
      };
    }
  ]);

}).call(this);



// WEBPACK FOOTER //
// ./scripts/job-application-history/viewJobApplicationBody.js